import {
  ShoppingRecurrenceCycle,
  ShoppingRecurrenceEditionStatus,
  ShoppingRecurrenceStatus
} from '@infrab4a/connect';

const recurrenceStatusLabels: Record<ShoppingRecurrenceStatus, string> = {
  [ShoppingRecurrenceStatus.ACTIVE]: 'Ativa',
  [ShoppingRecurrenceStatus.PAUSED]: 'Pausada',
  [ShoppingRecurrenceStatus.CANCELLED]: 'Cancelada',
  [ShoppingRecurrenceStatus.PAYMENT_FAILED]: 'Falha no pagamento',
  [ShoppingRecurrenceStatus.WAITING_STOCK]: 'Aguardando estoque'
};

const recurrenceCycleLabels: Record<ShoppingRecurrenceCycle, string> = {
  [ShoppingRecurrenceCycle.MONTHLY]: 'Mensal',
  [ShoppingRecurrenceCycle.BIMONTHLY]: 'Bimestral',
  [ShoppingRecurrenceCycle.QUARTERLY]: 'Trimestral'
};

const editionStatusLabels: Record<ShoppingRecurrenceEditionStatus, string> = {
  [ShoppingRecurrenceEditionStatus.SCHEDULED]: 'Agendada',
  [ShoppingRecurrenceEditionStatus.PAUSED]: 'Pausada',
  [ShoppingRecurrenceEditionStatus.SKIPPED]: 'Pulada',
  [ShoppingRecurrenceEditionStatus.PROCESSING]: 'Processando',
  [ShoppingRecurrenceEditionStatus.FINISHED]: 'Finalizada',
  [ShoppingRecurrenceEditionStatus.PAYMENT_FAIL]: 'Falha no pagamento',
  [ShoppingRecurrenceEditionStatus.AWAITING_PAYMENT]: 'Aguardando pagamento',
  [ShoppingRecurrenceEditionStatus.STOCK_VALIDATION]: 'Validação de estoque',
  [ShoppingRecurrenceEditionStatus.CANCELLED]: 'Cancelada'
};

export function getRecurrenceStatusLabel(
  status: ShoppingRecurrenceStatus
): string {
  return recurrenceStatusLabels[status] ?? status;
}

export function getRecurrenceCycleLabel(
  cycle: ShoppingRecurrenceCycle
): string {
  return recurrenceCycleLabels[cycle] ?? String(cycle);
}

export function getEditionStatusLabel(
  status: ShoppingRecurrenceEditionStatus
): string {
  return editionStatusLabels[status] ?? status;
}

export function getAllRecurrenceStatuses(): Array<{
  label: string;
  value: ShoppingRecurrenceStatus;
}> {
  return Object.values(ShoppingRecurrenceStatus).map((value) => ({
    label: getRecurrenceStatusLabel(value),
    value
  }));
}

export function getAllEditionStatuses(): Array<{
  label: string;
  value: ShoppingRecurrenceEditionStatus;
}> {
  return Object.values(ShoppingRecurrenceEditionStatus).map((value) => ({
    label: getEditionStatusLabel(value),
    value
  }));
}

export function getAllRecurrenceCycles(): Array<{
  label: string;
  value: ShoppingRecurrenceCycle;
}> {
  return [
    ShoppingRecurrenceCycle.MONTHLY,
    ShoppingRecurrenceCycle.BIMONTHLY,
    ShoppingRecurrenceCycle.QUARTERLY
  ].map((value) => ({
    label: getRecurrenceCycleLabel(value),
    value
  }));
}
